import React, { useEffect, useState } from "react";


import { motion, useAnimation } from "framer-motion";
import IMGOne from "../../assets/testimonials/1.jpg";
import IMGTwo from "../../assets/testimonials/2.jpg";
import IMGThree from "../../assets/testimonials/3.jpg";
import IMGFour from "../../assets/testimonials/4.jpg";

const phones = [IMGOne, IMGTwo, IMGThree, IMGFour];

const delay = 8000;


const SlideShow = () => {


    const [index, setIndex] = React.useState(0);
    const timeoutRef = React.useRef(null);
    const controls = useAnimation();
    const [shown, hasShown] = useState(false)

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(() => {
            controls.set({ opacity: 0.1 });
            if (index < 3) {
                setIndex((prevIndex) => (prevIndex = prevIndex + 1));
            }else{
                setIndex(0)
            }

                controls.start({
                    opacity: 1,
                    transition: { duration: 1.5 },
                });
            hasShown(true)
        }, delay);

        return () => {
            resetTimeout();
        };
    }, [index]);

    return (
        <div className="slideShow">

            {!shown && index === 0 && (
                <img className="slider__image" src={phones[0]} alt="" />
            )}

            {shown && index === 0 && (
                <img className="slider__image" src={phones[3]} alt="" />
            )}

            {phones[index - 1] && (
                <img className="slider__image" src={phones[index - 1]} alt="" />
            )}



            {phones[index] && (
                <motion.img
                    className="slider__imageTwo"
                    animate={controls}
                    src={phones[index]}
                    alt=""
                />
            )}
        </div>
    );
};

export default SlideShow;
